
import { AsistenteEnLineaComponent } from './asistente-en-linea.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { LocalStorageService, LOCAL_SERVICE_STORAGE } from './services/local-storage.service';
import { LOCAL_STORAGE } from 'ngx-webstorage-service';
import { AsistenciaMenuModule } from './components/asistencia-menu/asistencia-menu.module';
import { AsistenteVentanaModule } from './components/asistente-ventana/asistente-ventana.module';



@NgModule({
   declarations: [
      AsistenteEnLineaComponent,
   ],
   imports: [
      BrowserModule,
      FormsModule,
      HttpClientModule,
      AsistenteVentanaModule,
      AsistenciaMenuModule
   ],
   exports: [
      AsistenteEnLineaComponent
   ],
   providers: [
      LocalStorageService,
      { provide: LOCAL_SERVICE_STORAGE, useExisting: LOCAL_STORAGE }

   ],
   bootstrap: [
      AsistenteEnLineaComponent
   ]
})
export class AsistenteEnLineaModule { }
